import { render } from "./Booking-Button.vue?vue&type=template&id=4e447a56"
import script from "./Booking-Button.vue?vue&type=script&lang=js"
export * from "./Booking-Button.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src515844760/src/osteopath-uk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__